const GET_HELP_REQUEST_CATEGORY = "GET_HELP_REQUEST_CATEGORY";
const GET_HELP_REQUEST_CATEGORY_SUCCESS = "GET_HELP_REQUEST_CATEGORY_SUCCESS";
const GET_HELP_REQUEST_CATEGORY_FAIL = "GET_HELP_REQUEST_CATEGORY_FAIL";
 
const GET_HELPREQUEST_POSTGET = "GET_HELPREQUEST_POSTGET";
const GET_HELPREQUEST_POSTGET_SUCCESS = "GET_HELPREQUEST_POSTGET_SUCCESS";
const GET_HELPREQUEST_POSTGET_FAIL = "GET_HELPREQUEST_POSTGET_FAIL";
 

const BASE_ENDPOINT = "/MasterData";
const initialValues = {
  loading: false,
  hasError: false,
  categories: [],
  societies:[]
};

const masterData = (state = initialValues, action) => {
  switch (action.type) {
    case GET_HELP_REQUEST_CATEGORY: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_HELP_REQUEST_CATEGORY_SUCCESS: {
      return {
        ...state,
        categories: action.payload.data,
        loading: false,
      };
    }

    case GET_HELP_REQUEST_CATEGORY_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }


    case GET_HELPREQUEST_POSTGET: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_HELPREQUEST_POSTGET_SUCCESS: {
      const {societies,categories} = action.payload.data;
      return {
        ...state,
        categories: categories,
        societies:societies,
        loading: false,
      };
    }

    case GET_HELPREQUEST_POSTGET_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }

    default: {
      return state;
    }
  }
};


export const getHelpRequestCategories = () => {
  return {
    type: GET_HELP_REQUEST_CATEGORY,
    payload: {
      request: {
        method: "GET",
        url: BASE_ENDPOINT + "/HelpRequest/Categories",
      },
    },
  };
};


export const getHelpRequestPostGet = () => {
  return {
    type: GET_HELPREQUEST_POSTGET,
    payload: {
      request: {
        method: "GET",
        url: BASE_ENDPOINT + "/HelpRequest/PostGet",
      },
    },
  };
};

export default masterData;
